import { createContext, useContext, useEffect, useState } from 'react'
import { emitCustomEvent, useCustomEventListener } from 'react-custom-events'

export const StepperContext = createContext()

export const CurrentView = (p) => {
  
  const { View, props } = useContext(StepperContext)
  const pr = {...props, ...p}
  return <View {...pr} />
}

export default function ViewStepper({ views, complete, sendEvent, initialView, onBack, children }) {
  if (!views?.length) return console.error('No views supplied')

  const parentContext = useContext(StepperContext)
  const [isWaitingForPoll, setIsWaitingForPoll] = useState(false)

  const initialId = (initialView && views.find(v => v.id === initialView)) ? initialView : views[0].id
  const [steps, setSteps] = useState([initialId])

  // Listen for waiting for poll state
  useCustomEventListener('BOOKING_WAITING_FOR_POLL', ({ waiting }) => {
    setIsWaitingForPoll(waiting || false)
  }, [])

  const getCurrentId = () => {
    return steps[steps.length - 1]
  }

  const getCurrentView = () => {
    const id = getCurrentId()
    const view = views.find(item => item.id === id)
    return [id, view?.component, view?.props]
  }

  const prev = (id) => {
    // Don't allow navigation when waiting for poll
    if (isWaitingForPoll) {
      return
    }
    // If a requested id is not in steps but in views ie. jump back to a prev not visited view...
    if (typeof id === 'string' && steps.findIndex(item => item === id) === -1 && views.findIndex(item => item.id === id)) {
      const index = views.findIndex(item => item.id === id)
      setSteps(views.filter((item, i) => i < index + 1).map(item => item.id))
    }
    else if (typeof id === 'string' && steps.findIndex(item => item === id) !== -1) {
      const index = steps.findIndex(item => item === id)
      setSteps(previous => previous.slice(0, index + 1)) 
    }
    else if (steps.length > 1) {
      setSteps(previous => previous.slice(0, previous.length - 1))
    }
    else if (onBack) {
      onBack()
    }
    else if (parentContext?.prev) {
      parentContext.prev(id)
    }
  }

  const next = (id) => {
    // Don't allow navigation when waiting for poll (except for done step which is handled by ConfirmBooking)
    if (isWaitingForPoll && id !== 'done') {
      return
    }
    if (typeof id !== 'string') {
      const index = views.findIndex(item => item.id === getCurrentId())
      if (index + 1 < views.length) {
        id = views[index + 1].id
      }
      else if (parentContext?.next) {
        parentContext.next()
      }
      else if (complete) {
        complete()
      }
    }
    if (typeof id === 'string' && views.findIndex(item => item.id === id) !== -1) {
      setSteps(previous => [...previous, id]) 
    }
    // TODO: Remove this, used for debugging only
    // else {
    //   console.error(`No view "${id}" found!`)
    // }
  }

  const reset = () => {
    setSteps([views[0].id])
  }

  const [id, View, props] = getCurrentView()

  // Emit event with the current id for parent components
  // NOTE: maybe add an id for the stepper also
  useEffect(() => {
    if (sendEvent === true) {
      emitCustomEvent('VIEW_CHANGE', { id })
    }
  }, [id, sendEvent])

  return (
    <StepperContext.Provider value={{ 
      prev, 
      next, 
      reset,
      parentContext, 
      id,
      View,
      props
    }}>
      {typeof children !== 'function' ? children : children({ prev, next, reset, parentContext, id, View, props })}
    </StepperContext.Provider>
  )
}
